import { createSlice } from '@reduxjs/toolkit'

export const reviewsStations = createSlice({
  name: 'reviewsStations',
  initialState: {
    data: [],
    stationsNF: [],
    average: 0,
    loading: false,
    reviewing: 0,
    published: 0,
    pending: 0,
    replyRate: 0,
    replyTime: 0,
    moderation: 0,
    avgPositive: 0,
    reported: 0,
    sixDaysAgoPending: 0,
    sixDaysAgoPublished: 0,
  },
  reducers: {
    setReviewsStation: (state, item) => {
      state.stationsNF = item.payload
      state.data = item.payload
    },
    setLoadingReviewsStation: (state, item) => {
      state.loading = item.payload
    },
    setAverageStation: (state, item) => {
      state.average = item.payload?.toPrecision(2)
    },
    setReviewingReviewsStations: (state, item) => {
      state.reviewing = item.payload
    },
    setPublishedReviewsStations: (state, item) => {
      state.published = item.payload
    },
    setPendingReviewsStations: (state, item) => {
      state.pending = item.payload
    },
    setReplyRate: (state, item) => {
      state.replyRate = item.payload
    },
    setReplyTime: (state, item) => {
      state.replyTime = item.payload
    },
    setModeration: (state, item) => {
      state.moderation = item.payload
    },
    setAvgPositive: (state, item) => {
      state.avgPositive = item.payload
    },
    setReported: (state, item) => {
      state.reported = item.payload
    },
    setSixDaysAgoPending: (state, item) => {
      state.sixDaysAgoPending = item.payload
    },
    setSixDaysAgoPublished: (state, item) => {
      state.sixDaysAgoPublished = item.payload
    }
  }
})

export const { setReviewsStation, setLoadingReviewsStation, setAverageStation,
  setReviewingReviewsStations, setPublishedReviewsStations, setPendingReviewsStations,
  setReplyRate, setReplyTime, setModeration, setAvgPositive, setReported, setSixDaysAgoPending, setSixDaysAgoPublished } = reviewsStations.actions
export default reviewsStations.reducer